module.exports = __webpack_public_path__ + "static/img/2.552a1e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/eng/2.png
// module id = 74in
// module chunks = 0